import { useEffect, useRef } from 'react'
import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import InputBase from '@mui/material/InputBase'
import SvgIcon from '@mui/material/SvgIcon'
import CloseIcon from '@mui/icons-material/Close'
import SearchIcon from '@mui/icons-material/Search'
import { COMMAND_BAR_PANEL_BG } from './commandBar.styles'

type CommandBarSearchInputProps = {
  value: string
  placeholder: string
  onChange: (value: string) => void
  onClose: () => void
}

export const CommandBarSearchInput = ({
  value,
  placeholder,
  onChange,
  onClose,
}: CommandBarSearchInputProps) => {
  const inputRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    const frame = window.requestAnimationFrame(() => {
      inputRef.current?.focus()
    })
    return () => window.cancelAnimationFrame(frame)
  }, [])

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        px: 2,
        py: 1.5,
        borderBottom: '1px solid rgba(255, 255, 255, 0.08)',
      }}
    >
      <SvgIcon sx={{ fontSize: 20, color: 'rgba(255,255,255,0.45)' }}>
        <SearchIcon />
      </SvgIcon>
      <InputBase
        inputRef={inputRef}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder={placeholder}
        fullWidth
        sx={{
          color: 'common.white',
          fontSize: '0.95rem',
          backgroundColor: 'transparent',
          '& input': {
            backgroundColor: 'transparent',
          },
          '& input:-webkit-autofill': {
            WebkitBoxShadow: `0 0 0 100px ${COMMAND_BAR_PANEL_BG} inset`,
            WebkitTextFillColor: '#fff',
            caretColor: '#fff',
          },
          '& input::placeholder': {
            color: 'rgba(255,255,255,0.35)',
            opacity: 1,
          },
        }}
      />
      <IconButton
        size="small"
        onClick={onClose}
        aria-label="close"
        sx={{ color: 'rgba(255,255,255,0.55)' }}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </Box>
  )
}
